import { render, staticRenderFns } from "./TrialSignerPicker.vue?vue&type=template&id=0ca1f5a7&"
import script from "./TrialSignerPicker.vue?vue&type=script&lang=js&"
export * from "./TrialSignerPicker.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports